import { type CustomPOIModalTranslations } from '@smg-real-estate/seeker-app-shared-components';
import { ComposerTranslation } from 'vue-i18n';

export const modalTranslations = (t: ComposerTranslation): CustomPOIModalTranslations => ({
  title: t('travelTimeCustomPOI.modal.title').toString(),
  description: t('travelTimeCustomPOI.modal.description').toString(),
  address: {
    label: t('travelTimeCustomPOI.modal.fields.address.label').toString(),
    placeholder: t('travelTimeCustomPOI.modal.fields.address.placeholder').toString(),
  },
  name: {
    label: t('travelTimeCustomPOI.modal.fields.name.label').toString(),
    placeholder: t('travelTimeCustomPOI.modal.fields.name.placeholder').toString(),
  },
  transportType: {
    label: t('travelTimeCustomPOI.modal.fields.transportType.label').toString(),
  },
  button: {
    label: t('travelTimeCustomPOI.modal.button.apply').toString(),
  },
});
